import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()((theme: any) => ({
  typeButtonWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  title: {
    width: '100%',
    fontSize: '20px',
    padding: 20,
    textAlign: 'center',
    borderBottom: '1px solid #929292',
  },
  card: {
    backgroundColor: theme.backgrounds.cardBackground,
    marginBottom: 22,
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
    borderRadius: '5px',
    minHeight: 50,
  },
  cardDisabled: {
    backgroundColor: theme.backgrounds.cardBackground,
    marginBottom: 22,
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
    borderRadius: '5px',
    minHeight: 50,
    opacity: 0.5,
  },
  cardContent: {
    display: 'flex',
    alignItems: 'center',
    padding: '2% 10%',
    '&:last-child': {
      paddingBottom: '2%',
    },
  },
  cardContentMobile: {
    display: 'flex',
    alignItems: 'center',
    padding: '1% 2%',
    '&:last-child': {
      paddingBottom: '2%',
    },
  },
  cardData: {
    width: '100%',
  },
  blockTitle: {
    color: theme.scenes.title,
    fontSize: '18px',
  },
  blockTitleTop: {
    color: theme.scenes.titleTop,
    fontSize: '18px',
  },
  blockDescription: {
    fontSize: '18px',
    display: 'inline-block',
    marginRight: 5,
  },
  blockDescriptionTop: {
    fontSize: '16px',
    color: theme.scenes.descriptionTop,
  },
  buttonWrapper: {
    display: 'flex',
    justifyContent: 'flex-end',
    padding: 0,
  },
  button: {
    textDecoration: 'underline !important',
    '-webkit-text-decoration': 'underline',
  },
  svgWrapper: {
    width: 60,
    marginRight: 15,
  },
  additionalDesc: {
    display: 'inline-block',
    marginLeft: 5,
    marginRight: 5,
    width: 10,
    height: 10,
    border: '1px solid rgba(0,0,0, 0.3)',
  },
  cardText: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  clearButton: {
    marginLeft: 5,
  },
  clearIcon: {
    fontSize: 40,
    position: 'absolute',
    top: 6,
    left: 6,
  },
}))

export default useStyles
